<template>
  <div class="main-container">
    <Header :meta="dataMeta" />

    <KewirausahaanMainWrapper :meta="dataMeta" />

    <Footer bgFooter="old-blue-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu />

    <!-- back to top start -->
    <back-to-top class="scroll-top-orange" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
<script>
import Header from "../../components/header-top-fix-blue";
import Footer from "../../components/footer-2";
import OffCanvasMobileMenu from "@/components/off-canvas-mobile-menu";
import KewirausahaanMainWrapper from "../../components/sections/KewirausahaanBlue";

export default {
  name: "Kewirausahaan",
  props: ["dataMeta"],
  components: {
    Header,
    Footer,
    OffCanvasMobileMenu,
    KewirausahaanMainWrapper,
  },

  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Kewirausahaan`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
};
</script>
